<template>
  <div class="white">
    <header-guideline />
    <v-flex xs12 class="bluePurple py-3 px-4 sticky-header">
      <v-row class="px-10">
        <v-breadcrumbs
          class="px-0 subtitle-2 mt-0 pt-0 pb-1 breadcrumbs-items white--text"
          :items="breadcrumbs"
        ></v-breadcrumbs>
        <v-spacer></v-spacer>
        <a class="white--text fs-14" @click="homePage">Back to home page</a>
      </v-row>
    </v-flex>
    <v-flex xs12 class="py-5 px-3">
      <!-- <v-tabs class="elevation-0 tab-guideline" vertical>
        <v-tabs-slider class="tab-guideline"></v-tabs-slider>

        <v-tab
          v-for="i in 3"
          :key="i"
          :href="`#tab-${i}`"
          class="primary--text"
        >
          Dashboard {{ i }}
        </v-tab>

        <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i" class="pa-0">
          <h2 class="bluePurple--text mb-0 pb-0">Dashboard</h2>
          <label class="greylight--text fs-13">Last Update - 29 May 2020</label>
          <div class="greydark--text pt-5 font-weight-medium">
            cek
          </div>
        </v-tab-item>
      </v-tabs> -->

      <v-row class="px-8" justify="space-between">
        <v-col cols="3">
          <v-perfect-scroll
            class="drawer-menu--scroll-guideline-menu"
            :settings="scrollSettings"
          >
            <v-treeview
              v-model="tree"
              :open.sync="open"
              :items="items"
              :active.sync="active"
              activatable
              return-object
              item-key="name"
              open-on-click
              :hoverable="false"
              class="guideline-tree"
              active-class="guideline-tree-active"
            >
            </v-treeview>
          </v-perfect-scroll>
        </v-col>

        <v-col cols="9" class="d-flex">
          <v-scroll-y-transition mode="out-in">
            <v-col cols="12">
              <div v-if="active.length === 0">
                <h2 class="bluePurple--text mb-0 pb-0">
                  Mofin
                </h2>
                <div class="greydark--text pt-5 font-weight-medium">
                  Here you can find out how to use the features in NAV
                  Investment Tool
                </div>
              </div>
              <v-card v-else class="pt-0" flat>
                <v-card-text class="pt-0">
                  <h2 class="bluePurple--text mb-0 pb-0 text-capitalize">
                    {{ active[0].name }}
                  </h2>
                  <div v-if="active[0].detail !== null">
                    <div class="greylight--text fs-13 mb-5">
                      Last Update {{ active[0].detail.version }} -
                      {{ formatDate(active[0].detail.updated_at) }}
                    </div>

                    <v-perfect-scroll
                      class="drawer-menu--scroll-guideline"
                      :settings="scrollSettings"
                    >
                      <v-flex
                        xs12
                        class="greydark--text font-weight-medium img-size"
                        v-html="active[0].detail.description"
                      >
                      </v-flex>
                    </v-perfect-scroll>
                  </div>
                  <div v-else>
                    <label class="greylight--text fs-13">Last Update -</label>
                    <div class="greydark--text pt-5 font-weight-medium">
                      Guideline text for
                      <span class="text-lowercase">{{ active[0].name }}</span>
                      have not been entered yet
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-flex>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import headerGuideline from '../../../components/contentManagement/header';
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'header-guideline': headerGuideline
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 60
      },
      progressDialogLoading: false,
      active: [],
      open: [],
      tree: [],
      breadcrumbs: [
        {
          text: 'Help Center'
          // disabled: true,
          // href: '#'
        },
        {
          text: 'Manual Guideline'
        },
        {
          text: 'Features'
        },
        {
          text: 'Dashboard'
        }
      ],
      items: [
        // {
        //   id: 1,
        //   name: '.git'
        // },
        // {
        //   id: 2,
        //   name: 'node_modules'
        // },
        // {
        //   name: 'public',
        //   children: [
        //     {
        //       id: 3,
        //       name: 'static',
        //       file: 'png'
        //     },
        //     {
        //       id: 4,
        //       name: 'favicon.ico',
        //       file: 'png'
        //     }
        //   ]
        // }
      ]
    };
  },
  watch: {
    open(val) {
      if (val.length > 1) {
        this.open.splice(0, 1);
      }
    },
    active() {
      this.breadcrumbs.splice(3, 2);
      this.breadcrumbs.push(
        { text: this.open[0].name },
        { text: this.active[0].name }
      );
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    homePage() {
      this.$router.push({
        name: 'content-management'
      });
    },
    async getData() {
      this.progressDialogLoading = true;
      return await this.$store
        .dispatch('texts/getHierarchy')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.items = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
<style>
.drawer-menu--scroll-guideline {
  max-height: 380px;
  overflow: auto;
}
.drawer-menu--scroll-guideline-menu {
  max-height: 450px;
  overflow: auto;
}
@media (min-height: 768px) {
  .drawer-menu--scroll-guideline {
    max-height: 500px !important;
    overflow: auto;
  }
  .drawer-menu--scroll-guideline-menu {
    max-height: 570px !important;
    overflow: auto;
  }
}
</style>
